<template>
  <div>
    <ODropdown ref="dropdown" placement="bottom-start">
      <OTooltip :text="$t('components.message.elements.send.emoji.title')" placement="top">
        <a class="relative h-8 w-8 flex items-center justify-center rounded-xl cursor-pointer text-gray-600 hover:bg-gray-200 hover:dark:bg-gray-800 dark:text-gray-400">
          <o-icon icon="smile" />
        </a>
      </OTooltip>

      <template #content>
        <EmojiPicker
          :native="true"
          :theme="$colorMode.value === 'dark' ? 'dark' : 'light'"
          @select="insert"
        />
      </template>
    </ODropdown>
  </div>
</template>

<script setup lang="ts">
import EmojiPicker from 'vue3-emoji-picker'
import 'vue3-emoji-picker/css'

const _value = defineModel<string>('value', { default: '' })

const insert = (emoji: any) => {
  _value.value += emoji.i
}
</script>
